import { render, staticRenderFns } from "./AnfrageForm.vue?vue&type=template&id=6a275a99"
import script from "./AnfrageForm.vue?vue&type=script&lang=js"
export * from "./AnfrageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports